export default "__VITE_ASSET__Cc$056IM__"